<template>
  <v-snackbar
    v-model="show"
    :color="color"
    bottom
    right
  >
    <v-icon
      dark
      class="mr-3"
      v-text="color === `success` ? `mdi-check-circle` : color === `error` ? `mdi-alert` : `mdi-information`"
    >
      mdi-alert
    </v-icon>

    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        dark
        text
        v-bind="attrs"
        @click="show = false"
      >
        CERRAR
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    show: false,
    message: '',
    color: ''
  }),

  created () {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'SHOW_MESSAGE') {
        this.message = mutation.payload.message
        this.color = mutation.payload.type
        this.show = true
      }
    })
  }
}
</script>

<style scoped>

</style>
